
import MonthlySavingsCalculator from '../components/calculators/MonthlySavingsCalculator';
import { useToolSEO } from '../hooks/useSEO';

const MonthlySavingsPage = () => {
  const seoContent = useToolSEO('monthly-savings-calculator');
  
  return (
    <>
      {seoContent}
      <section className="bg-white py-16 fade-in">
        <MonthlySavingsCalculator />
      </section>
    </>
  );
};

export default MonthlySavingsPage;
